module.exports = __webpack_public_path__ + "img/pic-15.4fd19f77.jpg";